var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"change-mail"}},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('change-mail-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }